import { useEffect } from "react";

/**
 * Sets document.title and updates/creates the meta tags used for SEO and
 * social previews. Idempotent across navigations.
 */
export default function useDocumentSEO({ title, description, ogImage, lang }) {
  useEffect(() => {
    if (typeof document === "undefined") return;
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", ogImage || "");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage || "");
    if (lang && document.documentElement.lang !== lang) {
      document.documentElement.lang = lang;
    }
  }, [title, description, ogImage, lang]);
}

function setMeta(attrName, attrValue, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
